/**
 * Remembers "I was posting an event" across the sign-in round trip, so someone
 * who signs up mid-form lands back on the form with their draft intact.
 * Browser-only; safe to call from effects and handlers.
 */
const KEY = "squadflight.submitIntent";

export function setSubmitIntent(): void {
  try {
    window.sessionStorage.setItem(KEY, "1");
  } catch {
    /* private mode — they just land on their profile instead */
  }
}

export function takeSubmitIntent(): boolean {
  try {
    const value = window.sessionStorage.getItem(KEY);
    if (value) window.sessionStorage.removeItem(KEY);
    return value === "1";
  } catch {
    return false;
  }
}
